"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearfix = clearfix;
exports.default = void 0;

/**
 * @public
 * @decription  Basic css for clearfix feature.
 * @returns {string}
 */
function clearfix() {
  return "\n    &::after {\n      content: \"\";\n      display: table;\n      clear: both;\n    }\n  ";
}

var _default = {
  clearfix: clearfix
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bootstrap-styled/css-mixins/lib/clearfix.js
// module id = 124
// module chunks = 0